import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CONFERENCE } from '../mock';
import { ElectionReminder } from './ConferenceRecap';

export const HomeRecapBanner = () => (
  <section className="max-w-7xl mx-auto px-4 pt-12" data-testid="home-recap-banner">
    <div className="rounded-md overflow-hidden border-2 border-gold/70 bg-gradient-to-br from-[#102818] to-cbtu-black grid md:grid-cols-[1.2fr_0.8fr] items-center">
      <div className="p-8 md:p-12">
        <div className="chip mb-3 inline-block">2026 REGIONAL CONFERENCE</div>
        <h2 className="font-display text-4xl md:text-5xl text-cbtu-cream leading-tight">THANK YOU, <span className="gold-text-fill">REGION III!</span></h2>
        <p className="text-cbtu-text/90 mt-3 leading-relaxed">Thank you to all of the unions, sponsors, vendors and volunteers who helped make this year&apos;s conference in Jacksonville a success.</p>
        <Link to="/conference" className="gold-button mt-6 px-6 py-3 rounded-sm inline-flex items-center gap-2" data-testid="home-recap-btn">See the Conference Recap <ArrowRight size={16} /></Link>
        <ElectionReminder className="mt-6" />
      </div>
      <Link to="/conference" className="block p-4 md:p-6" aria-label="View the conference recap">
        <img src={CONFERENCE.featuredImage.src} alt={CONFERENCE.featuredImage.alt} className="w-full max-w-sm mx-auto rounded-md gold-border" loading="lazy" data-testid="home-recap-image" />
      </Link>
    </div>
  </section>
);
